import { Avatar } from "@chakra-ui/avatar";
import { IconButton } from "@chakra-ui/button";
import { HamburgerIcon } from "@chakra-ui/icons";
import { HStack } from "@chakra-ui/layout";
import LogoImg from "../../assets/logo/logo.png";

type Props = {
  onOpenMenu: () => void;
};

export const ClientMobileHeader: React.FC<Props> = ({ onOpenMenu }) => {
  return (
    <HStack p="30" justifyContent="space-between">
      <Avatar size="lg" src={LogoImg} alt={"Sabeda"} />

      <IconButton
        variant="outline"
        colorScheme="purple"
        aria-label="Open menu"
        icon={<HamburgerIcon />}
        onClick={onOpenMenu}
      />
    </HStack>
  );
};
